import { ArrowRight, ListChecks, PhoneCall } from "lucide-react";
import { Button } from "../ui/button";

export default function QuickQuizCTAMontaz({ onQuizClick }) {
  const scrollToForm = () => {
    const el = document.getElementById("lead-form");
    if (el) el.scrollIntoView({ behavior: "smooth", block: "center" });
    const input = document.getElementById("hero-phone");
    setTimeout(() => input?.focus(), 600);
  };

  return (
    <section
      id="quiz"
      className="py-12 lg:py-16 bg-white"
      data-testid="quick-quiz-cta-montaz"
    >
      <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="bg-brand-surface rounded-3xl border border-brand-blue/10 shadow-sm p-6 sm:p-10">
          <div className="grid lg:grid-cols-2 gap-6 lg:gap-10 items-center">
            <div>
              <p className="text-xs font-bold uppercase tracking-[0.18em] text-brand-blue">
                Szybki quiz
              </p>
              <h2 className="mt-3 font-heading font-bold text-2xl sm:text-3xl lg:text-4xl tracking-tight text-brand-ink leading-tight">
                Nie chcesz rozmawiać od razu?
              </h2>
              <p className="mt-3 text-brand-muted">
                Odpowiedz na kilka pytań — pomoże nam to dobrać instalację i instalatora.
              </p>
              <div className="mt-6 flex flex-col sm:flex-row gap-3">
                <Button
                  onClick={onQuizClick}
                  data-testid="start-quiz-btn"
                  className="group h-14 rounded-full bg-brand-yellow hover:bg-brand-yellowHover text-brand-yellowFg font-bold text-base px-7 shadow-lg hover:scale-[1.02] active:scale-95 transition-all"
                >
                  <ListChecks className="h-5 w-5 mr-2" />
                  Rozpocznij szybki quiz
                  <ArrowRight className="ml-2 h-5 w-5 group-hover:translate-x-1 transition-transform" />
                </Button>
              </div>
            </div>

            {/* Fallback CTA */}
            <div className="bg-white rounded-2xl p-5 sm:p-6 border border-brand-border">
              <div className="flex items-center gap-2 text-brand-blue">
                <PhoneCall className="h-4 w-4" />
                <span className="text-xs font-bold uppercase tracking-wider">Wolisz rozmowę?</span>
              </div>
              <p className="mt-2 font-heading font-bold text-xl text-brand-ink leading-snug">
                Możesz też zostawić numer
              </p>
              <p className="mt-1 text-brand-muted text-sm">
                Oddzwonimy w 5–10 minut.
              </p>
              <Button
                onClick={scrollToForm}
                data-testid="quiz-fallback-cta-btn"
                className="mt-4 h-12 rounded-full bg-brand-blue hover:bg-brand-blueHover text-white font-semibold w-full sm:w-auto px-6"
              >
                Zostaw numer — oddzwonimy
                <ArrowRight className="ml-2 h-4 w-4" />
              </Button>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
